export default "__VITE_ASSET__6$HKdBjs__"